/* V323 · 04.10.2026 — "דף השירות האישי" בתוך תוצאת האבחון.
   הוראת זהר: "יש ליצור דף דינמי שעונה לכל השאלות של הלקוח, בעצם זה דף ה'שירות' שהלקוח יקבל" · "תבחר אתה, תבנה הגירסה".
   מקור התוכן: דפי המצב החיים עצמם (sw-lp-*, 23 דפים באותו מבנה: b2 · b3 · סרטון · b4 · b5) — אותו טקסט שזהר אישר, מקור אחד.
   הדף נקרא ב-fetch מאותו דומיין, נבנה מחדש מטקסט בלבד (textContent, בלי HTML מהדף), ונפתח כשאלות סגורות.
   שורות שמזכירות משקל (ק"ג) מדף המצב לא נכנסות — המשקל נקבע באבחון.
   STRATEGY-0410-PERSONAL-SERVICE-PAGE. */
(function () {
  'use strict';
  var OR_URL = '/blogs/%D7%9E%D7%90%D7%9E%D7%A8%D7%99%D7%9D-%D7%95%D7%9E%D7%97%D7%A7%D7%A8%D7%99%D7%9D/%D7%9E%D7%9B%D7%AA%D7%91-%D7%94%D7%9E%D7%9C%D7%A6%D7%94-%D7%A8%D7%A4%D7%95%D7%90%D7%99-%D7%A4%D7%A8%D7%95%D7%A4-%D7%A8%D7%90%D7%95%D7%91%D7%9F-%D7%90%D7%95%D7%A8-%D7%94%D7%93%D7%A1%D7%94-%D7%A2%D7%99%D7%9F-%D7%9B%D7%A8%D7%9D';
  var SEV_HE = { mild: 'חומרה קלה', moderate: 'חומרה בינונית', severe: 'חומרה גבוהה' };
  var KG_RE = /ק["״']?ג|קילו/;
  var cache = {};
  var cur = null;

  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function ev(name, params) {
    try {
      params = params || {};
      window.dataLayer = window.dataLayer || [];
      var o = { event: name }; for (var k in params) o[k] = params[k]; window.dataLayer.push(o);
      if (typeof gtag === 'function') gtag('event', name, params);
      if (typeof clarity === 'function') clarity('event', name);
    } catch (e) {}
  }
  function priceOf(kg) { try { return (typeof SHOPIFY_PRICES !== 'undefined' && SHOPIFY_PRICES[kg]) || 0; } catch (e) { return 0; } }
  function money(n) { var r = Math.round(n * 100) / 100; return '₪' + (r % 1 ? r.toFixed(2) : String(r)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  /* V324 · מתי נציג יחזור — חלון הפעילות הקרוב (אותם חלונות של V314), לפי שעון ישראל.
     נשלח כ-callback {date, window} כדי שהמוח ייצור תגית "מבקש-שיחה-נציג" + משימה בתחילת החלון. */
  var SVC_DAYS = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
  var SVC_WIN_WEEK = [[9, 12], [12, 15], [15, 18], [18, 20]], SVC_WIN_FRI = [[9, 13]];
  function p2(n) { return (n < 10 ? '0' : '') + n; }
  function ilNow() {
    try {
      var f = new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Jerusalem', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
      var g = function (t) { return parseInt(f.filter(function (x) { return x.type === t; })[0].value, 10); };
      return { y: g('year'), m: g('month'), d: g('day'), min: (g('hour') % 24) * 60 + g('minute') };
    } catch (e) { var d = new Date(); return { y: d.getFullYear(), m: d.getMonth() + 1, d: d.getDate(), min: d.getHours() * 60 + d.getMinutes() }; }
  }
  function nextSlot() {
    var n = ilNow();
    for (var i = 0; i < 10; i++) {
      var dt = new Date(Date.UTC(n.y, n.m - 1, n.d + i)), wd = dt.getUTCDay();
      var wins = wd === 6 ? [] : (wd === 5 ? SVC_WIN_FRI : SVC_WIN_WEEK);
      for (var j = 0; j < wins.length; j++) {
        if (i === 0 && wins[j][1] * 60 - n.min < 45) continue; /* חלון שנגמר בעוד פחות מ-45 דק' — לא מוצע (כמו V314) */
        var dm = p2(dt.getUTCDate()) + '.' + p2(dt.getUTCMonth() + 1);
        var he = i === 0 ? 'היום' : (i === 1 ? 'מחר' : 'ביום ' + SVC_DAYS[wd]);
        return {
          date: dt.getUTCFullYear() + '-' + p2(dt.getUTCMonth() + 1) + '-' + p2(dt.getUTCDate()),
          win: p2(wins[j][0]) + ':00-' + p2(wins[j][1]) + ':00',
          winHe: 'בין ' + wins[j][0] + ':00 ל-' + wins[j][1] + ':00',
          he: he, dm: dm,
          label: (i === 0 ? 'היום' : (i === 1 ? 'מחר' : 'יום ' + SVC_DAYS[wd])) + ' · ' + (i <= 1 ? 'יום ' + SVC_DAYS[wd] + ' ' : '') + dm
        };
      }
    }
    return null;
  }
  function callWhen() { var s = nextSlot(); return s ? s.he : 'בהקדם'; }

  function css() {
    if ($('sw-svc-css')) return;
    var s = document.createElement('style'); s.id = 'sw-svc-css';
    s.textContent =
      '#sw-svc-top,#sw-svc-q{max-width:560px;margin:.7rem auto 0;direction:rtl;text-align:right;font-family:Heebo,HeeboFB,Arial,sans-serif;color:#122E38}' +
      '#sw-svc-top .why{margin:.1rem 0 .45rem;font-size:.95rem;line-height:1.55;text-align:center;color:#33414a !important}' +
      '#sw-svc-top .pay{margin:0 0 .5rem;font-size:.88rem;text-align:center;color:#33414a !important}' +
      '#sw-svc-top .risk{margin:0 0 .7rem;background:#EEF6F0;border:1.5px solid #BFE3CC;border-radius:12px;padding:.6rem .8rem;font-weight:800;font-size:.92rem;line-height:1.5;text-align:center;color:#14532D !important}' +
      '#sw-svc-call{display:block;width:100%;min-height:54px;border:0;border-radius:12px;background:#B84A1C !important;color:#fff !important;font-family:inherit;font-size:1.08rem;font-weight:900;cursor:pointer}' +
      '#sw-svc-call[disabled]{background:#1C7C46 !important;cursor:default}' +
      '#sw-svc-call:focus-visible,#sw-svc-q summary:focus-visible,#sw-svc-q .vbtn:focus-visible{outline:3px solid #E8632E;outline-offset:2px}' +
      /* V332 · 4.1 — איזון שלושת הכפתורים. עד V331 "לרכישה באתר" היה היחיד ללא מילוי,
         והיחיד בחצי רוחב ובגובה 46px — מול כפתור שיחה מלא ברוחב מלא ובגובה 54px.
         כל 18 שראו תוצאה ראו אותו, ואפס לחצו. עכשיו שני מסלולי הפעולה שווים בעוצמתם,
         והמבקר בוחר. סדר האלמנטים לא שונה. */
      '#sw-svc-top .row{display:grid;grid-template-columns:1fr;gap:.5rem;margin-top:.5rem}' +
      '#sw-svc-top .row a{display:flex;align-items:center;justify-content:center;border-radius:12px;font-weight:800;text-decoration:none}' +
      '#sw-svc-top .row a.buy{min-height:54px;font-size:1.08rem;font-weight:900;border:0;color:#fff !important;background:#122E38 !important}' +
      '#sw-svc-top .row a.wa{min-height:48px;font-size:.99rem;background:#15803D !important;color:#fff !important}' +
      '#sw-svc-top .row a:focus-visible{outline:3px solid #E8632E;outline-offset:2px}' +
      '#sw-svc-done{margin:.5rem 0 0;font-weight:800;color:#14532D !important;text-align:center}' +
      '#sw-svc-q h3{margin:1.1rem 0 .15rem;font-size:1.2rem;font-weight:900;color:#122E38 !important}' +
      '#sw-svc-q .sub{margin:0 0 .6rem;font-size:.9rem;color:#4A5A61 !important}' +
      '#sw-svc-q details{border:1.5px solid #D7E0E3;border-radius:12px;margin:0 0 .5rem;background:#fff;overflow:hidden}' +
      '#sw-svc-q summary{list-style:none;cursor:pointer;min-height:50px;display:flex;align-items:center;justify-content:space-between;gap:.6rem;padding:.7rem .9rem;background:#F4F7F8;font-weight:800;font-size:1rem;color:#122E38 !important}' +
      '#sw-svc-q summary::-webkit-details-marker{display:none}' +
      '#sw-svc-q summary:after{content:"+";font-size:1.3rem;font-weight:700;color:#B84A1C}' +
      '#sw-svc-q details[open] summary:after{content:"−"}' +
      '#sw-svc-q .b{padding:.75rem .95rem .9rem;font-size:.97rem;line-height:1.65;color:#22313a !important}' +
      '#sw-svc-q .b p{margin:0 0 .55rem}' +
      '#sw-svc-q .b ol,#sw-svc-q .b ul{margin:0 0 .55rem;padding-inline-start:1.2rem}' +
      '#sw-svc-q .b li{margin:0 0 .35rem}' +
      '#sw-svc-q .q{margin:0 0 .55rem;background:#FDF6EF;border-radius:10px;padding:.6rem .75rem}' +
      '#sw-svc-q .q b{display:block;margin-top:.2rem;font-size:.88rem}' +
      '#sw-svc-q .note{font-size:.82rem;color:#5a6a70 !important}' +
      '#sw-svc-q .vbtn{position:relative;display:block;width:100%;aspect-ratio:16/9;border:0;border-radius:11px;overflow:hidden;background:#0a1a20 center/cover no-repeat;cursor:pointer;margin:0 0 .6rem;padding:0}' +
      '#sw-svc-q .vbtn span{position:absolute;inset:auto 0 0 0;padding:.55rem .7rem;background:linear-gradient(transparent,rgba(0,0,0,.75));color:#fff;font-weight:800;font-size:.92rem;text-align:right}' +
      '#sw-svc-q .vbtn i{position:absolute;top:50%;left:50%;width:62px;height:62px;margin:-31px 0 0 -31px;border-radius:50%;background:rgba(232,99,46,.95);display:flex;align-items:center;justify-content:center}' +
      '#sw-svc-q .vwrap{position:relative;width:100%;aspect-ratio:16/9;margin:0 0 .6rem;border-radius:11px;overflow:hidden;background:#000}' +
      '#sw-svc-q .vwrap iframe{position:absolute;inset:0;width:100%;height:100%;border:0}' +
      '#sw-svc-q a.more{display:inline-block;margin-top:.2rem;font-weight:800;color:#B4471C !important;text-decoration:none}' +
      '#sw-svc-q .also{margin:.4rem 0 0;font-size:.92rem}' +
      '#sw-diag-result.sw-has-svc #sw-res-wa,#sw-diag-result.sw-has-svc #sw-res-call,#sw-diag-result.sw-has-svc #sw-res-wanote,#sw-diag-result.sw-has-svc #sw-res-personal{display:none !important}' +
      '#sw-diag-result.sw-surg #sw-svc-top,#sw-diag-result.sw-surg #sw-svc-q{display:none !important}';
    document.head.appendChild(s);
  }

  function place(id, afterEl) {
    var el = $(id);
    if (!el) { el = document.createElement('div'); el.id = id; el.className = 'sw-hide-surg'; }
    if (afterEl && afterEl.parentNode) afterEl.parentNode.insertBefore(el, afterEl.nextSibling);
    return el;
  }

  /* ── החלק העליון: למה, תשלומים, סיכון, פעולה ראשית ── */
  function renderTop(o) {
    var res = $('sw-diag-result'); if (!res) return;
    var anchor = $('sw-ladder');
    if (!anchor || anchor.style.display === 'none') anchor = $('sw-res-kgsub') || $('sw-res-kg');
    var top = place('sw-svc-top', anchor);
    var bits = [];
    if (o.winLabel) bits.push('<b>' + esc(o.winLabel) + '</b>');
    if (SEV_HE[o.sev]) bits.push(SEV_HE[o.sev]);
    if (o.people) bits.push(esc(o.people) + ' נפשות בחדר'); /* V325 */
    if (o.room) bits.push('חדר ' + esc(o.room) + ' מ״ר');
    var p = (!o.dual && o.kg) ? priceOf(o.kg) : 0;
    var when = callWhen();
    top.innerHTML =
      (bits.length ? '<p class="why">ההמלצה מבוססת על: ' + bits.join(' · ') + '</p>' : '') +
      (p ? '<p class="pay">או 6 תשלומים ללא ריבית של ' + money(p / 6) + ' · משלוח חינם · 3 שנות אחריות</p>' : '<p class="pay">משלוח חינם · 3 שנות אחריות</p>') +
      '<p class="risk">30 ימי התנסות בליווי אישי · הסיכון שלכם: ₪300 — לא מחיר המנורה</p>' +
      '<button type="button" id="sw-svc-call">📞 שנציג יחזור אליי ' + esc(when) + '</button>' +
      '<div class="row"><a class="buy" id="sw-svc-buy" href="' + esc(o.buy || '/collections/all') + '">לרכישה באתר ←</a>' +
      '<a class="wa" id="sw-svc-wa" href="' + esc(o.wa || 'https://wa.me/972557228865') + '" target="_blank" rel="noopener">💬 וואטסאפ</a></div>' +
      '<p id="sw-svc-done" role="status" style="display:none"></p>';
    $('sw-svc-call').addEventListener('click', function () { callMe(); });
    $('sw-svc-buy').addEventListener('click', function () { ev('svc_buy_click', { condition_key: o.winKey || '' }); });
    $('sw-svc-wa').addEventListener('click', function () { ev('svc_wa_click', { condition_key: o.winKey || '' }); });
  }

  function callMe() {
    var btn = $('sw-svc-call'), done = $('sw-svc-done');
    var p = window._swLastPayload;
    if (!p || !window._swContact || typeof window.swSendLead !== 'function') {
      var g = $('sw-diag-gate'); if (g) { g.style.display = 'block'; try { g.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
      ev('svc_call_no_contact', {});
      return;
    }
    var s = nextSlot(); /* מחושב ברגע הלחיצה — התוצאה יכולה להישאר פתוחה זמן רב */
    p.contact = window._swContact;
    p.preferred_channel = 'שיחה עם נציג';
    if (s) {
      p.callback = { date: s.date, window: s.win };
      p.notes = 'מבקש שיחה עם נציג החברה · ' + s.label + ' · ' + s.win + ' · מדף השירות · (V325)' + (window.swNoteTail && window.swNoteTail() ? ' · ' + window.swNoteTail() : '');
    } else {
      p.notes = 'מבקש שיחה עם נציג החברה · מדף השירות · (V325)' + (window.swNoteTail && window.swNoteTail() ? ' · ' + window.swNoteTail() : '');
    }
    try { window.swSendLead(p, false, true); } catch (e) {}
    if (btn) { btn.disabled = true; btn.textContent = '✓ קיבלנו את הבקשה'; }
    if (done) { done.textContent = s ? ('נציג יתקשר אליכם ' + s.he + ' (' + s.dm + '), ' + s.winHe + ', למספר שהשארתם.') : 'נציג יתקשר אליכם בהקדם למספר שהשארתם.'; done.style.display = 'block'; }
    ev('svc_call_request', { when: s ? s.he : '', callback_date: s ? s.date : '', callback_window: s ? s.win : '', condition_key: (cur && cur.winKey) || '' });
  }

  /* ── השאלות ── */
  function item(qid, title, bodyHtml, open) {
    return '<details data-q="' + qid + '"' + (open ? ' open' : '') + '><summary>' + esc(title) + '</summary><div class="b">' + bodyHtml + '</div></details>';
  }
  function liRich(li) {
    var st = li.querySelector('strong'); var all = txt(li).replace(/^\d+\s*/, '');
    if (st) { var s = txt(st); var rest = all.indexOf(s) === 0 ? all.slice(s.length) : all.replace(s, ''); return '<b>' + esc(s) + '</b> ' + esc(rest.trim()); }
    return esc(all);
  }
  function parse(html) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var out = { ok: false };
    var b2 = d.getElementById('sw-lp-b2'), b3 = d.getElementById('sw-lp-b3'), b4 = d.getElementById('sw-lp-b4'), b5 = d.getElementById('sw-lp-b5'), vs = d.getElementById('sw-cond-video');
    if (b2) out.body = [].map.call(b2.querySelectorAll('p.lp-p'), txt).filter(Boolean);
    if (b3) {
      out.mechLead = [].map.call(b3.querySelectorAll('p.lp-p'), txt).filter(Boolean);
      out.mechSteps = [].map.call(b3.querySelectorAll('ol li'), liRich).filter(Boolean);
    }
    if (vs) {
      var ifr = vs.querySelector('iframe'); var src = ifr ? (ifr.getAttribute('src') || '') : '';
      var m = src.match(/embed\/([A-Za-z0-9_-]{6,20})/); if (m) out.video = { id: m[1], title: txt(vs.querySelector('h2')) };
    }
    if (b4) {
      out.time = [].map.call(b4.querySelectorAll('.lp-tc'), function (el) { var c = el.cloneNode(true); [].forEach.call(c.querySelectorAll('.lp-tc-go'), function (x) { x.remove(); }); return liRich(c); }).filter(Boolean);
      out.quotes = [].map.call(b4.querySelectorAll('.tgrid .t'), function (t) { return { q: txt(t.querySelector('p')), who: txt(t.querySelector('.who')) }; }).filter(function (x) { return x.q; });
      out.disc = txt(b4.querySelector('.skdisc'));
      out.stat = txt(b4.querySelector('.lp-stat'));
    }
    if (b5) {
      out.guar = txt(b5.querySelector('.big'));
      out.how = [].map.call(b5.querySelectorAll('ul.lp-list li'), txt).filter(function (t) { return t && !KG_RE.test(t); });
      out.trust = txt(b5.querySelector('.lp-trust'));
    }
    out.ok = !!(out.mechSteps && out.mechSteps.length) || !!(out.time && out.time.length);
    return out;
  }
  function videoHtml(v) {
    if (!v) return '';
    return '<button type="button" class="vbtn" data-yt="' + esc(v.id) + '" style="background-image:url(https://i.ytimg.com/vi/' + esc(v.id) + '/hqdefault.jpg)" aria-label="צפו בסרטון: ' + esc(v.title || 'הסבר של זהר') + '">' +
      '<i><svg width="26" height="26" viewBox="0 0 24 24" fill="#fff" aria-hidden="true"><polygon points="8 5 19 12 8 19 8 5"></polygon></svg></i>' +
      '<span>📹 ' + esc(v.title || 'זהר מסביר') + '</span></button>';
  }
  function renderQ(o, c) {
    var box = $('sw-svc-q'); if (!box) return;
    var label = o.winLabel || 'המצב שלכם';
    var h = '<h3>השאלות שלכם על ' + esc(label) + '</h3><p class="sub">בחרו מה מעניין אתכם — כל תשובה נפתחת בלחיצה.</p>';
    if (c && c.ok) {
      var mech = videoHtml(c.video);
      (c.mechLead || []).slice(0, 1).forEach(function (t) { mech += '<p><b>' + esc(t) + '</b></p>'; });
      if (c.mechSteps && c.mechSteps.length) mech += '<ol>' + c.mechSteps.map(function (s) { return '<li>' + s + '</li>'; }).join('') + '</ol>';
      (c.mechLead || []).slice(1).forEach(function (t) { mech += '<p>' + esc(t) + '</p>'; });
      h += item('mech', 'מה המנורה עושה במצב שלכם?', mech, true);
      if (c.body && c.body.length) h += item('body', 'מה קורה אצלי בגוף?', c.body.map(function (t) { return '<p>' + esc(t) + '</p>'; }).join(''));
      if (c.time && c.time.length) h += item('time', 'מתי ארגיש שינוי?', '<ul>' + c.time.map(function (t) { return '<li>' + t + '</li>'; }).join('') + '</ul>' + (c.stat ? '<p>' + esc(c.stat) + '</p>' : ''));
      if (c.quotes && c.quotes.length) h += item('quotes', 'מה מספרים לקוחות?', c.quotes.map(function (x) { return '<div class="q">' + esc(x.q) + (x.who ? '<b>— ' + esc(x.who) + '</b>' : '') + '</div>'; }).join('') + (c.disc ? '<p class="note">' + esc(c.disc) + '</p>' : ''));
      if ((c.how && c.how.length) || c.guar) h += item('how', 'איך משתמשים, ואיך הליווי עובד?', (c.guar ? '<p><b>' + esc(c.guar) + '</b></p>' : '') + (c.how && c.how.length ? '<ul>' + c.how.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>' : ''));
    } else if (c) {
      h += item('mech', 'מה המנורה תעשה?', '<p>המנורה מיועדת לעבוד 9 שעות ביממה, מומלץ בזמן השינה, לפי ההוראות.</p>' + (o.pageUrl ? '<a class="more" href="' + esc(o.pageUrl) + '">קראו על ' + esc(label) + ' ←</a>' : ''), true);
    } else {
      h += '<p class="sub" id="sw-svc-loading">טוען את התשובות למצב שלכם…</p>';
    }
    h += item('proof', 'זה מוכח?', '<p><b>97% מהלקוחות נשארו עם המנורה.</b></p><p>נחקר באוניברסיטה העברית ובטכניון.</p><a class="more" href="' + OR_URL + '">מכתב ההמלצה הרפואי של פרופ׳ ראובן אור, הדסה עין כרם ←</a>');
    var p = (!o.dual && o.kg) ? priceOf(o.kg) : 0;
    h += item('price', 'מחיר, תשלומים, משלוח ואחריות', (p ? '<p>' + esc(o.kg) + ' ק״ג: ' + money(p) + ' · או 6 תשלומים ללא ריבית של ' + money(p / 6) + '</p>' : '') + '<p>' + esc((c && c.trust) || 'רכישה חד-פעמית לכל החיים · 3 שנות אחריות · משלוח חינם') + '</p>');
    if (o.pageUrl && c && c.ok) h += '<p class="also"><a class="more" href="' + esc(o.pageUrl) + '">כל המידע על ' + esc(label) + ' ←</a></p>';
    var others = (o.conds || []).filter(function (x) { return x.key !== o.winKey && typeof SW_COND_PAGES !== 'undefined' && SW_COND_PAGES[x.key] && SW_COND_PAGES[x.key] !== o.pageUrl; });
    if (others.length) h += '<p class="also">בחרתם גם: ' + others.map(function (x) { return '<a class="more" href="' + esc(SW_COND_PAGES[x.key]) + '">' + esc(x.label) + ' ←</a>'; }).join(' · ') + '</p>';
    box.innerHTML = h;
    [].forEach.call(box.querySelectorAll('details'), function (dt) {
      dt.addEventListener('toggle', function () { if (dt.open) ev('svc_q_open', { q: dt.getAttribute('data-q'), condition_key: o.winKey || '' }); });
    });
    [].forEach.call(box.querySelectorAll('.vbtn'), function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-yt'); var w = document.createElement('div'); w.className = 'vwrap';
        w.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&hl=he" title="סרטון הסבר" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
        b.parentNode.replaceChild(w, b);
        ev('svc_video_play', { video_id: id, condition_key: o.winKey || '' });
      });
    });
  }

  window.swSvcRender = function (o) {
    try {
      if (!o || !$('sw-diag-result')) return;
      css();
      if (!o.winKey && o.conds && o.conds[0]) o.winKey = o.conds[0].key;
      if (!o.winLabel && o.conds && o.conds[0]) o.winLabel = o.conds[0].label;
      o.pageUrl = (typeof SW_COND_PAGES !== 'undefined' && SW_COND_PAGES[o.winKey]) || '';
      cur = o;
      $('sw-diag-result').classList.add('sw-has-svc');
      renderTop(o);
      /* V332 · 2.1 — svc_shown נורה כאן, ברגע שהבלוק באמת מוצג (renderTop סינכרוני).
         עד V331 הוא נורה רק בתוך ה-then של ה-fetch לדף המצב, ולכן ספר 5 מתוך 18 —
         מדד של סיום טעינה, לא של הצגה. אירוע סיום הטעינה נשמר בשם svc_q_ready. */
      ev('svc_shown', { condition_key: o.winKey || '' });
      var after = $('sw-res-talk') || $('sw-svc-top');
      place('sw-svc-q', after);
      var url = o.pageUrl;
      if (!url) { renderQ(o, { ok: false }); ev('svc_q_ready', { condition_key: o.winKey || '', content: 'generic' }); return; }
      if (cache[url]) { renderQ(o, cache[url]); ev('svc_q_ready', { condition_key: o.winKey || '', content: cache[url].ok ? 'page' : 'generic' }); return; }
      renderQ(o, null);
      fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) { var c = parse(html); cache[url] = c; if (cur === o) renderQ(o, c); ev('svc_q_ready', { condition_key: o.winKey || '', content: c.ok ? 'page' : 'generic' }); })
        .catch(function () { cache[url] = { ok: false }; if (cur === o) renderQ(o, { ok: false }); ev('svc_q_ready', { condition_key: o.winKey || '', content: 'error' }); });
    } catch (e) {}
  };
  /* מצב "נקבע ניתוח" — דף השירות לא מוצג (שיחה בלבד, V279) */
  window.swSvcHide = function () { try { var r = $('sw-diag-result'); if (r) r.classList.remove('sw-has-svc'); ['sw-svc-top', 'sw-svc-q'].forEach(function (id) { var e = $(id); if (e) e.innerHTML = ''; }); } catch (e) {} };
})();
